import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PurchaseSection = ({ ebook }) => {
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);

  const handleDownload = () => {
    setIsAdding(true);

    const cartItem = {
      id: ebook?.id,
      title: ebook?.title,
      author: ebook?.author,
      price: ebook?.price,
      coverImage: ebook?.coverImage,
      coverImageAlt: ebook?.coverImageAlt,
      format: 'pdf',
      quantity: 1,
      addedAt: new Date()?.toISOString()
    };

    const existingCart = JSON.parse(localStorage.getItem('cart') || '[]');
    const existingItemIndex = existingCart?.findIndex(
      item => item?.id === ebook?.id
    );

    if (existingItemIndex === -1) {
      existingCart?.push(cartItem);
    }

    localStorage.setItem('cart', JSON.stringify(existingCart));
    window.dispatchEvent(new Event('cartUpdated'));

    setTimeout(() => {
      setIsAdding(false);
      navigate('/shopping-cart');
    }, 500);
  };

  return (
    <div className="bg-card rounded-lg shadow-md p-4 md:p-6 space-y-5 sticky top-20">
      {/* Price */}
      <div className="space-y-2">
        <div className="flex items-baseline gap-3">
          <span className="text-3xl md:text-4xl font-heading font-bold text-foreground">
            ${ebook?.price}
          </span>
          {ebook?.originalPrice && (
            <span className="text-lg text-muted-foreground line-through">
              ${ebook?.originalPrice}
            </span>
          )}
        </div>
        {ebook?.originalPrice && (
          <div className="inline-flex items-center gap-1 bg-success/10 text-success px-2 py-1 rounded text-sm font-medium">
            <Icon name="TrendingDown" size={14} />
            Save ${(ebook?.originalPrice - ebook?.price)?.toFixed(2)}
          </div>
        )}
      </div>

      {/* Download Button */}
      <div className="space-y-3">
        <Button
          variant="default"
          fullWidth
          size="lg"
          onClick={handleDownload}
          loading={isAdding}
          iconName="Download"
          iconPosition="left"
        >
          Download
        </Button>

        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Icon name="Lock" size={14} />
          <span>Secure checkout with SSL encryption</span>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="pt-4 border-t border-border space-y-3">
        <div className="flex items-start gap-3">
          <Icon name="Download" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="space-y-1">
            <p className="text-sm font-medium text-foreground">Instant Download</p>
            <p className="text-xs text-muted-foreground">Access immediately after purchase</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="RefreshCw" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="space-y-1">
            <p className="text-sm font-medium text-foreground">Lifetime Access</p>
            <p className="text-xs text-muted-foreground">Download anytime from your account</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="Shield" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="space-y-1">
            <p className="text-sm font-medium text-foreground">Money-Back Guarantee</p>
            <p className="text-xs text-muted-foreground">30-day satisfaction guarantee</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseSection;